import axios from 'axios'
import { getCouponsApi } from '@/utils'
import type { FullCoupon } from '@/interface/Coupon'

export interface IGetCouponsParams {
  endpoint: string
  accountId: string
  couponId?: string
  isClientUser: boolean
  token: string
}

export const fetchCoupons = async (
  params: IGetCouponsParams,
): Promise<FullCoupon[]> => {
  const endpoint = getCouponsApi()
  const path = 'admin/coupons'

  const response = await axios.get(`${endpoint}/${path}`, {
    headers: {
      Authorization: `Bearer ${params.token}`,
    },
    params: {
      accountId: params.accountId,
      isClient: params.isClientUser,
    },
  })

  return await response.data
}

export const addNewCoupon = async (params: IGetCouponsParams, data: any) => {
  const endpoint = getCouponsApi()
  const path = 'user/coupons'

  const response = await axios.get(`${endpoint}/${path}`, {
    headers: {
      Authorization: `Bearer ${params.token}`,
    },
    params: {
      accountId: params.accountId,
    },
  })

  return await response.data
}
